import { SHOW_TOAST } from "../actions/toastActions";

export interface IToastState {
  open: boolean;
  message?: string;
  severity?: "success" | "info" | "warning" | "error";
}

const initialState: IToastState = {
  open: false,
  message: "",
};

const toastReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        ...action.value,
      };
    default:
      return state;
  }
};

export default toastReducer;
